/**
 * Registration Process Config
 */

interface IAccountRegistrationConfigType {
  id: string;
  label: string;
}

function alphaSort(arr: IAccountRegistrationConfigType[]) {
  return arr.sort((a, b) => {
    if (a.label === 'Other') {
      return 1;
    }

    if (b.label === 'Other') {
      return -1;
    }

    return a.label < b.label ? -1 : 1;
  });
}

export const jobTypes: IAccountRegistrationConfigType[] = alphaSort([
  // {
  //   id: 'Sm9iVHlwZToxMDAx',
  //   label: 'Administration',
  // },
  // {
  //   id: 'Sm9iVHlwZToxMDAy',
  //   label: 'Art Director',
  // },
  // {
  //   id: 'Sm9iVHlwZToxMDAz',
  //   label: 'Copywriter',
  // },
  {
    id: 'Sm9iVHlwZToxMDA0',
    label: 'Creative',
  },
  {
    id: 'Sm9iVHlwZToxMDA1',
    label: 'Editor/Post Producer',
  },
  {
    id: 'Sm9iVHlwZToxMDA2',
    label: 'Music Supervisor',
  },
  {
    id: 'Sm9iVHlwZToxMDA3',
    label: 'Producer',
  },
  {
    id: 'Sm9iVHlwZToxMDA4',
    label: 'Other',
  },
  {
    id: 'Sm9iVHlwZToxMDA5',
    label: 'Art Buyer',
  },
  {
    id: 'Sm9iVHlwZToxMDEw',
    label: 'Director',
  },
  {
    id: 'Sm9iVHlwZToxMDEx',
    label: 'Founder, Owner & President',
  },
  {
    id: 'Sm9iVHlwZToxMDEy',
    label: 'Artist',
  },
]);

export const companySizes: IAccountRegistrationConfigType[] = alphaSort([
  { id: '', label: `I'm self-employed` },
  { id: '', label: '2-10' },
  { id: '', label: '11-50' },
  { id: '', label: '51-100' },
  { id: '', label: '100+' },
]);

export const industries: IAccountRegistrationConfigType[] = alphaSort([
  {
    id: 'SW5kdXN0cnk6MzAwMQ==',
    label: 'Advertising Agency',
  },
  {
    id: 'SW5kdXN0cnk6MzAwMg==',
    label: 'Broadcast Network Studio',
  },
  {
    id: 'SW5kdXN0cnk6MzAwMw==',
    label: 'Advertising Production House',
  },
  {
    id: 'SW5kdXN0cnk6MzAwNA==',
    label: 'In-House Agency',
  },
  {
    id: 'SW5kdXN0cnk6MzAwNQ==',
    label: 'Music House',
  },
  // {
  //   id: 'SW5kdXN0cnk6MzAwNg==',
  //   label: 'Production House',
  // },
  {
    id: 'SW5kdXN0cnk6MzAwNw==',
    label: 'Other',
  },
  {
    id: 'SW5kdXN0cnk6MzAwOA==',
    label: 'Film & TV Production',
  },
  {
    id: 'SW5kdXN0cnk6MzAwOQ==',
    label: 'Trailer House',
  },
  {
    id: 'SW5kdXN0cnk6MzAxMA==',
    label: 'Artist',
  },
  {
    id: 'SW5kdXN0cnk6MzAxMQ==',
    label: 'Music and Sound Studio',
  },
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/Registration/config.ts